import { useMemo } from "react";
import { IonItem } from "@ionic/react";
import { Options } from "easymde";
import Markdown from "react-markdown";
import SimpleMdeReact from "react-simplemde-editor";

import { translate } from "~utils";

import styles from "./EditableMarkdown.module.css";
import { EditableFieldsBase } from "./types";

type EditableMarkdownProps = EditableFieldsBase & {
  isInset?: boolean;
  autoFocus?: boolean;
  // Overriding IonInput onchange prop type
  onChange: (value: string) => void;
};

export const EditableMarkdown: React.FC<EditableMarkdownProps> = ({
  isEditing,
  value,
  label,
  placeholder,
  onChange,
  className,
  lines,
  isInset,
  autoFocus = true,
}) => {
  const hideButtonOptions = useMemo(() => {
    // SimpleMDE requires options to be defined within a `useMemo` instead
    // of directly within the Options param. More on this here:
    //
    // https://github.com/RIP21/react-simplemde-editor?tab=readme-ov-file#options
    return {
      hideIcons: ["quote", "image", "preview", "side-by-side", "fullscreen", "guide"],
      placeholder,
    } as Options;
  }, [placeholder]);

  return (
    <IonItem className={`${className} w-full`} lines={lines}>
      {isEditing ? (
        <div className="w-full">
          {label && <p className={`font-medium ${isInset && "mt-2 mb-1"}`}>{label}</p>}
          <SimpleMdeReact
            value={value}
            options={hideButtonOptions}
            onChange={onChange}
            autoFocus={autoFocus}
          />
        </div>
      ) : (
        <div className="flex w-full gap-4 pb-4">
          <div className={isInset ? "px-4" : ""}>
            <p className={`font-medium ${isInset && "mt-2 mb-1"}`}>{label}</p>
            {value ? (
              <Markdown className={styles.markdownViewer}>{value}</Markdown>
            ) : (
              <span className="italic">{translate("NOT_PROVIDED")}</span>
            )}
          </div>
        </div>
      )}
    </IonItem>
  );
};
